import { Helmet } from "react-helmet-async";
import type { ReactNode } from "react";
import { PUBLIC_PAGE_META, canonicalFor } from "@/seo/publicPageMeta";

/**
 * Emits exactly one title, description and canonical (plus matching og:/twitter:)
 * for a core public marketing page, from the central PUBLIC_PAGE_META map.
 * Extra page-specific head tags (e.g. JSON-LD) can be passed as children.
 */
export function PublicPageSeo({ path, children }: { path: keyof typeof PUBLIC_PAGE_META | string; children?: ReactNode }) {
  const meta = PUBLIC_PAGE_META[path];
  if (!meta) return null;
  const url = canonicalFor(meta.path);
  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      {children}
    </Helmet>
  );
}
